export const FIRST_PAGE = 0
export const NO_PAGES = 0
export const PAGE_COUNT_DELTA = 1

export const MID_PAGE_LABEL = "..."

export const DEFAULT_PAGE_RANGE = 3
